import * as React from "react"

function MitoMicroLogo(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={130} height={24} viewBox="0 0 130 24" {...props}>
      <title>{"MITO Micro"}</title>
      <text
        transform="translate(-22 -19)"
        fill="#FFF"
        fillRule="evenodd"
        fontFamily="HyperwaveOne, Hyperwave One"
        fontSize={38.88}
      >
        <tspan x={24} y={40}>
          {"MIT"}
        </tspan>
        <tspan x={59.225} y={40} fontFamily="HyperwaveTwo, Hyperwave Two">
          {"O"}
        </tspan>
        <tspan x={70.151} y={40} letterSpacing={-3.096} />
        <tspan x={77.397} y={40} fontFamily="HyperwaveThree, Hyperwave Three">
          {"MICRO"}
        </tspan>
        <tspan x={139.397} y={30} fontFamily="neue-haas-grotesk-text,Helvetica Neue,Helvetica,Arial" fontSize={14} fontWeight={750}>
          &reg;
        </tspan>
      </text>
    </svg>
  )
}

export default MitoMicroLogo
